export default __webpack_public_path__ + "static/media/Kk.92a127fd.wav";